export const materialSatuan = [
    {
        data: "LBR"
    },
    {
        data: "M2"
    },
    {
        data: "MTR"
    },
    {
        data: "BTG"
    },
    {
        data: "KG"
    },
    {
        data: "GRAM"
    },
    {
        data: "TUBE"
    },
    {
        data: "KLG "
    },
    {
        data: "ROLL"
    },
    {
        data: "BH"
    },
    {
        data: "UNIT"
    },
    {
        data: "SET"
    },
    {
        data: "PSG"
    },
    {
        data: "BOX"
    },
    {
        data: "STRIP"
    },
    {
        data: "LTR"
    },
    {
        data: "LTR SET"
    },
    {
        data: "BTL"
    },
    {
        data: "GLN"
    },
    {
        data: "ZAK"
    },
]